import { render, staticRenderFns } from "./BaseLogin.vue?vue&type=template&id=cbb0bf72&scoped=true&"
import script from "./BaseLogin.vue?vue&type=script&lang=js&"
export * from "./BaseLogin.vue?vue&type=script&lang=js&"
import style0 from "./BaseLogin.vue?vue&type=style&index=0&id=cbb0bf72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb0bf72",
  null
  
)

export default component.exports